import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { useFooter } from '../../hooks';
import { Accordion } from './components/Accordion';
import { Group } from './components/Group';
import { Links } from './components/Links';
import { SITE_LINKS } from './constants';
import { Inner, Root } from './styles';

export const SiteLinks: FC = () => {
  const { getTestId } = useTestId();
  const { siteLinksColumns } = useFooter();
  const isMobile = useIsMobile();

  return (
    <Root data-testid={getTestId(SITE_LINKS)}>
      {isMobile ? (
        siteLinksColumns.map(({ title, children }) => (
          <Accordion
            key={title}
            header={title}
          >
            <Links items={children} />
          </Accordion>
        ))
      ) : (
        <Inner>
          {siteLinksColumns.map(({ title, children }) => (
            <Group
              key={title}
              header={title}
            >
              <Links items={children} />
            </Group>
          ))}
        </Inner>
      )}
    </Root>
  );
};
